import { DIAMOND_REQUEST_START, DIAMOND_REQUEST_SUCCESS, DIAMOND_UPDATE, DIAMOND_UPDATE_HASMORE } from "./diamondTypes"

export const startRequest = () => {
    return {
        type: DIAMOND_REQUEST_START
    }
}

export const setHasMore = value => {
    return {
        type: DIAMOND_UPDATE_HASMORE,
        payload: value
    }
}

export const successRequest = data => {
    return {
        type: DIAMOND_REQUEST_SUCCESS,
        payload: data
    }
}

export const updateDiamonds = diamonds => {
    return {
        type: DIAMOND_UPDATE,
        payload: diamonds
    }
}

export const updateDiamondsFromCollections = (collections) => {
    return async (dispatch) => {

        const isCollectionsEmpty = collections.size === 0;
    
        if(!isCollectionsEmpty) {
    
            const diamondsData = collections.docs.map((doc) => {
                return {
                    uid: doc?.id,
                    diamond: doc.data()?.diamond,
                    price: doc.data()?.price,
                    status: doc.data()?.status,
                    onlyGameAccountId: doc.data()?.onlyGameAccountId,
                    createdAt: doc.data()?.createdAt,
                    updatedAt: doc.data()?.updatedAt,
                    updatedBy: doc.data()?.updatedBy
                };
            });
    
            const lastDocId = collections.docs[collections.docs.length - 1];
    
            dispatch(successRequest({
                lastDocId: lastDocId,
                diamonds: diamondsData,
                hasMore: true,
            }));
        } else {
            dispatch(setHasMore(false));
        }
    }
}